import React, { useEffect, useRef, useState } from 'react';
import firebase from "../../firebaseConfig";
import "../../styles/generalTabs.css";
import {TiDelete, TiPlus} from "react-icons/ti";
import ReactQuill from "react-quill";

const StickingPlan = ({ user }) => {
    const [stickingPlanData, setStickingPlanData] = useState( [{},{},{},{},{}]);

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const data = docSnapshot?.data()?.StickingPlan_7;
                        setStickingPlanData(data);
                    }
                }
            } catch (error) {
                console.log(error);
                // Gérer les erreurs de récupération des données
            }
        };
        fetchInputValue();
    }, [user]);

    const updateStickingPlanData = (index, field, value) => {
        setStickingPlanData((prevData) => {
            const updatedData = [...prevData];
            updatedData[index][field] = value;
            return updatedData;
        });
    };

    const saveStickingPlanData = async () => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({ StickingPlan_7: stickingPlanData });
            }
        } catch (error) {
            console.log("Error saving data:", error);
            // Gérer les erreurs de sauvegarde des données
        }
    };

    const createNewMap = async () => {
        const updatedData = [...stickingPlanData];
        updatedData.push({});
        setStickingPlanData(updatedData);
    };

    const handleDelete = async (index) => {
        const updatedData = [...stickingPlanData];
        updatedData.splice(index, 1);
        setStickingPlanData(updatedData);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            saveStickingPlanData();
        }, 1000); // Définissez ici le délai de temporisation souhaité (en millisecondes)

        return () => {
            clearTimeout(timeoutId);
        };
    }, [stickingPlanData]);

    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-7">
            <h5 className={"mt-3"}>
                <span className="introText">
                    "It was character that got us out of bed, commitment that moved us into action, and discipline that enabled us to follow through." - Zig Ziglar
                </span>
            </h5>
            <div className="table-responsive d-flex flex-column align-items-center">
                <table className="table w-75">
                    <thead>
                        <tr>
                            <th>
                                <span style={{ textDecoration: "underline", fontSize: "1.5em" }}>OVERTHINKING & SELF-SABOTAGE</span><br/>
                                <span className={"subtitleMaj"}>WHAT ARE YOUR OVERTHINKING & SELF-SABOTAGE PATTERNS?</span>
                            </th>
                            <th>
                                <span style={{ textDecoration: "underline", fontSize: "1.5em" }}>COMMITMENT PLAN</span><br/>
                                <span className={"subtitleMaj"}>HOW CAN YOU SET YOUR MIND, COMMIT TO YOUR PLANS AND TAKE ACTION?</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {stickingPlanData?.map((item, index) => (
                            <tr key={index}>
                                <td><StickingPlanItem content={item.overthinking} field={"overthinking"} index={index} saveStickingPlanData={saveStickingPlanData} updateStickingPlanData={updateStickingPlanData}/></td>
                                <td><StickingPlanItem content={item.commitment} field={"commitment"} index={index} saveStickingPlanData={saveStickingPlanData} updateStickingPlanData={updateStickingPlanData}/></td>
                                <TiDelete style={{ fontSize: "2.3em", cursor:"pointer" }} className={"text-danger mt-4"} onClick={() => handleDelete(index)}/>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="w-100 d-flex justify-content-center">
                <TiPlus style={{ fontSize: "1.8em", cursor:"pointer" }} className={"text-primary"} onClick={createNewMap}/>
            </div>
        </div>
    );
};

export default StickingPlan;

const StickingPlanItem = ({ content, field, index, updateStickingPlanData })=> {
    const handleChange = (value) => {
        updateStickingPlanData(index, field, value);
    };

    return (
        <ReactQuill
            value={content}
            onChange={handleChange}
            modules={{ toolbar: []}}
        />
    );
};
